import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'rcp-button-container',
  template: `
    <div
      class="rcp-button-container"
      [class.column]="direction() === 'column'"
      [class.left]="(align() === 'left' && !reverseOrder()) || (align() === 'right' && reverseOrder())"
      [class.center]="align() === 'center'"
      [class.space-between]="align() === 'space-between'"
      [class.right]="(align() === 'right' && !reverseOrder()) || (align() === 'left' && reverseOrder())"
      [class.reverse-order]="reverseOrder()"
      [class.wrap]="wrap()"
    >
      <ng-content></ng-content>
    </div>
  `,
  host: {
    '[class.rcp-button-container-expand]': 'align() === "expand"',
    '[class.stack-when-small]': 'stackWhenSmall()',
  },
  styleUrls: ['./button-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ButtonContainerComponent {
  direction = input<'column' | 'row'>('row');
  align = input<'left' | 'center' | 'right' | 'space-between' | 'expand'>('left');
  reverseOrder = input<boolean>(false);
  wrap = input<boolean>(true);
  // TODO: Figure out a way to safely apply to button-containers by default.
  stackWhenSmall = input<boolean>(false);
}
